var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-page-header",
    { staticClass: "page-header", on: { back: _vm.back } },
    [
      _c(
        "div",
        {
          staticClass: "flex-align-center",
          staticStyle: { cursor: "pointer" },
          attrs: { slot: "title" },
          on: { click: _vm.back },
          slot: "title",
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-right": "10px", "font-size": "17px" } },
            [_vm._v("返回")]
          ),
          _vm._l(_vm.dataSource, function (item, index) {
            return _c(
              "div",
              { key: index, staticStyle: { "font-size": "17px" } },
              [
                _c(
                  "span",
                  {
                    style: {
                      color:
                        index === _vm.dataSource.length - 1
                          ? "#297EDE"
                          : "#262626",
                    },
                  },
                  [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                ),
                _vm.dataSource.length - 1 !== index
                  ? _c("span", { staticStyle: { margin: "0 5px" } }, [
                      _vm._v("/"),
                    ])
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }